import getTranslation from 'bdata-sns-shared/utils/getTranslation';

const getTieBreakerLabel = ({
  dictionary, 
  shortLabel = false, 
  awayTeam, 
  homeTeam
}) => {
    const dictionaryKey = shortLabel ? 'label_tiebreaker_short' : 'label_tiebreaker';
    const winnerAbbreviation = awayTeam.isWinner ? awayTeam.team.abbreviation : homeTeam.team.abbreviation;
    return getTranslation(
        dictionary, 
        dictionaryKey,
        `${winnerAbbreviation} wins${ !shortLabel ? ' (tiebreaker)' : ''}`, 
        { winnerAbbreviation }
    ) || '';
};

export default getTieBreakerLabel;